/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useRef, useState } from 'react';
import CBUtils from '@cb/apricot/CBUtils';
import { TagSet } from '@cb/apricot-react-button';
import { Icon } from '@cb/apricot-react-icon';
import cn from 'classnames';
import { useUID } from 'react-uid';
import { Input } from './Input';
import { Checkbox } from './Checkbox';
export const msLabelPosition = ['left', 'right'];
export const msTagPosition = ['top', 'bottom'];
const getOptionList = (msOptions) => {
    const newItems = [];
    msOptions.forEach((items) => {
        items.options.forEach((item) => {
            var _a, _b;
            newItems.push(Object.assign(Object.assign({}, item), { groupTitle: (_a = items.optgroup) === null || _a === void 0 ? void 0 : _a.title, groupDesc: (_b = items.optgroup) === null || _b === void 0 ? void 0 : _b.desc }));
        });
    });
    return newItems;
};
export const MultiSelect = ({ options, label, labelId, ariaLabel, ariaDescribedby, placeholder, placeholderId, selectId, required, floating = true, fieldName, defaultValue = [], value, inputId, className, filter, filterLabelValue = false, filterPlaceholder, filterAriaLabel, reset, disabled, fieldsetId, condensed = false, validation = true, noResultMsg = 'No Results', validationMsg, validationMsgRole, helperMsg, selectedLabel = 'Selected', closeOnSelect, selectAll, checkboxLabelPosition = 'right', groupedCheckbox = false, groupedDescription = true, maxCheckbox = 100, maxCheckboxText = `{availableOptions} option(s) available. Filter to select individual options.`, tags, tagPosition = 'bottom', tagSmall, tagIcon, onChange, onReset, onSelectAll, checkboxLabelFunc, groupLabelFunc, }) => {
    const [firstRound, setFirstLoad] = useState(true);
    const containerRef = useRef(null);
    const anchorRef = useRef(null);
    const [filterValue, setFilterValue] = useState('');
    const [grouped, setGrouped] = useState(false);
    const [visited, setVisited] = useState(false);
    const [selected, setSelected] = useState(defaultValue || value);
    const [expanded, setExpanded] = useState(false);
    const selectedCount = selected.filter((s) => !s.disabled).length;
    const valid = selected.length || expanded || !visited ? 'general' : 'error';
    const hasError = valid === 'error';
    const uid = useUID();
    const dropdownId = selectId || `apricot_multiselect_${uid}`;
    const dropdownMenuId = `${dropdownId}-menu`;
    const selectedCountId = `${dropdownId}-selectedCount`;
    const fLabelId = labelId || `${dropdownId}-floating`;
    const uid2 = useUID();
    const placeholderSpanId = placeholderId || `apricot_placeholder_${uid2}`;
    const inputMsg = hasError ? validationMsg : helperMsg;
    const msgId = inputMsg ? `${dropdownId}-${valid}-msg` : null;
    // eslint-disable-next-line no-prototype-builtins
    const optionList = (options === null || options === void 0 ? void 0 : options.some((item) => item.hasOwnProperty('optgroup')))
        ? getOptionList(options)
        : options;
    const availableOptions = optionList.filter((o) => {
        if (!filterValue) {
            return true;
        }
        const labelMatches = o.label.toLowerCase().includes(filterValue.toLowerCase());
        const valueMatches = filterLabelValue
            ? String(o.value).toLowerCase().includes(filterValue.toLowerCase())
            : true;
        return filterLabelValue ? labelMatches || valueMatches : labelMatches;
    });
    const filterRequired = availableOptions.length >= maxCheckbox;
    const allSelected = availableOptions.length > 0 &&
        availableOptions.every((o) => selected.find((s) => s.value === o.value));
    const dropdownClasses = cn('cb-multiselect-checkbox', expanded && 'open', selectedCount && 'cb-multiselect-checkbox-selected', validation && 'cb-validation-state', `cb-validation-${valid}`, disabled && 'cb-disabled');
    const eventFocusOut = () => {
        // when this is in a modal, checking a checkbox fires a focusout event
        // we need to pause before closing until we can determine if the focus is really outside this container
        setTimeout(() => {
            if (containerRef.current && !containerRef.current.contains(document.activeElement))
                setExpanded(false);
        }, 200);
    };
    const eventEscape = e => {
        if (e.keyCode === CBUtils.KEYS.ESC) {
            setExpanded(false);
            if (anchorRef.current && anchorRef.current.getAttribute('aria-expanded') === 'true') {
                anchorRef.current.focus();
            }
        }
    };
    const updateSelected = (updates) => {
        setSelected(updates);
        onChange && onChange(updates);
    };
    const groupBy = (array, key) => {
        // Return the end result
        return array.reduce((rv, x) => {
            // eslint-disable-next-line no-param-reassign
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };
    const getGroup = (group, revert) => {
        const item = availableOptions.filter((item) => {
            if (revert) {
                return (item === null || item === void 0 ? void 0 : item.groupTitle) !== group;
            }
            return (item === null || item === void 0 ? void 0 : item.groupTitle) === group;
        });
        return item;
    };
    const getSelectedByGroup = (group) => {
        return filterValue
            ? selected.filter((item) => (item === null || item === void 0 ? void 0 : item.groupTitle) === group && item.label.toLowerCase().includes(filterValue.toLowerCase())).length
            : selected.filter((item) => (item === null || item === void 0 ? void 0 : item.groupTitle) === group).length;
    };
    // groupedCheckbox: All selected
    const groupIsSelected = (group) => {
        const groupCount = getGroup(group, false).length;
        const groupSelected = getSelectedByGroup(group);
        return groupCount === groupSelected;
    };
    // groupedCheckbox: mix selected
    const groupIsMixed = (group) => {
        const groupCount = getGroup(group, false).length;
        const groupSelected = getSelectedByGroup(group);
        return groupSelected > 0 && groupSelected < groupCount;
    };
    const getDescribedBy = () => {
        if (msgId && ariaDescribedby) {
            return `${ariaDescribedby} ${msgId}`;
        }
        if (ariaDescribedby) {
            return ariaDescribedby;
        }
        return msgId;
    };
    const getLabelledBy = () => {
        if (ariaLabel)
            return null;
        let label = '';
        if (floating)
            label = fLabelId;
        if (expanded || selectedCount > 0)
            label += ` ${selectedCountId}`;
        return label.trim();
    };
    const getAriaLabel = () => {
        if (!ariaLabel)
            return null;
        let label = ariaLabel;
        if (expanded || selectedCount > 0)
            label += ` - ${selectedCount} ${selectedLabel}`;
        return label;
    };
    useEffect(() => {
        if (firstRound) {
            // eslint-disable-next-line no-prototype-builtins
            if (options === null || options === void 0 ? void 0 : options.some((item) => item.hasOwnProperty('optgroup'))) {
                const items = getOptionList(options).filter((item) => {
                    if (value) {
                        return ((value === null || value === void 0 ? void 0 : value.filter((obj) => obj.value === item.value && !obj.disabled).length) >
                            0);
                    }
                    if (defaultValue) {
                        return ((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.filter((obj) => obj.value === item.value && !obj.disabled).length) > 0);
                    }
                    return false;
                });
                setSelected(items);
            }
            else {
                setSelected(value || defaultValue || []);
            }
        }
        else {
            setSelected(value || []);
        }
        // firstRound && setSelected(value || defaultValue || []);
        // !firstRound && setSelected(value || []);
        setFirstLoad(false);
    }, [value]);
    useEffect(() => {
        if (expanded) {
            setVisited(true);
        }
        // GS-10441
        // else {
        //     // on close set focus to main tag
        //     anchorRef.current && anchorRef.current.focus();
        // }
    }, [expanded]);
    // A11Y
    useEffect(() => {
        // eslint-disable-next-line no-prototype-builtins
        setGrouped(!!(options === null || options === void 0 ? void 0 : options.some((item) => item.hasOwnProperty('optgroup'))));
        const container = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || null;
        container === null || container === void 0 ? void 0 : container.addEventListener('focusout', eventFocusOut);
        document.addEventListener('keydown', eventEscape);
        return () => {
            document.removeEventListener('focusout', eventFocusOut);
            document.removeEventListener('keydown', eventEscape);
        };
    }, [options]);
    useEffect(() => {
        if (reset) {
            setSelected([]);
            onReset && onReset();
        }
    }, [reset]);
    return (React.createElement("fieldset", { id: fieldsetId, disabled: disabled, className: cn('cb-multiselect-checkbox-container', condensed && 'cb-condensed', className), "data-cbtrack-comp": "apricot-react:multi-select" },
        tags && tagPosition === 'top' && selected.length > 0 && (React.createElement("div", { className: "cb-margin-bottom-32" },
            React.createElement(TagSet, { disabled: disabled, tagIcon: tagIcon, small: tagSmall, label: `Selected ${label}`, offScreen: "Remove", tags: selected.filter((s) => !s.disabled).map((s) => s.label), onClick: (tagName, e) => {
                    e.preventDefault();
                    if (!disabled) {
                        const remainingItems = selected.filter((s) => s.label !== tagName && !s.disabled);
                        updateSelected(remainingItems);
                        if (remainingItems.length <= 0) {
                            anchorRef.current && anchorRef.current.focus();
                        }
                    }
                } }))),
        React.createElement("div", { ref: containerRef },
            !floating &&
                (typeof label === 'string' ? (React.createElement("label", { id: fLabelId, htmlFor: dropdownId, className: required ? 'cb-required' : '' }, label)) : (label)),
            React.createElement("div", { className: dropdownClasses },
                React.createElement("div", { className: "flex-grow-1", tabIndex: -1 },
                    React.createElement("a", { ref: anchorRef, tabIndex: disabled ? -1 : 0, "aria-disabled": disabled, className: "cb-multiselect-checkbox-toggle", id: dropdownId, href: "/#", role: "button", "aria-label": getAriaLabel() || undefined, "aria-expanded": expanded, "aria-controls": dropdownMenuId, "aria-describedby": getDescribedBy() || undefined, "aria-labelledby": getLabelledBy() || undefined, onClick: e => {
                            e.preventDefault();
                            if (!disabled)
                                setExpanded(!expanded);
                        }, onKeyDown: (e) => {
                            const k = e.which || e.keyCode;
                            // space
                            if (k === 32) {
                                e.preventDefault();
                                if (!disabled)
                                    setExpanded(!expanded);
                            }
                        } },
                        floating &&
                            (typeof label === 'string' ? (React.createElement("span", { id: fLabelId, className: cn(required ? 'cb-required' : '', 'cb-label') }, label)) : (label)),
                        expanded || selectedCount ? (React.createElement("span", { id: selectedCountId, role: "status", className: "cb-font-weight-bold" },
                            selectedCount,
                            " ",
                            selectedLabel)) : (placeholder &&
                            !floating && (React.createElement("span", { id: placeholderSpanId, className: "cb-text-placeholder" }, placeholder))),
                        React.createElement("span", { className: "cb-multiselect-checkbox-toggle-icon" }, expanded ? (React.createElement(Icon, { name: "x-mark", decorative: true, size: "16" })) : (React.createElement(Icon, { name: "down", decorative: true })))),
                    expanded ? (React.createElement("div", { className: "cb-multiselect-checkbox-dropdown" },
                        filter || filterRequired ? (React.createElement("div", { className: "cb-multiselect-filter" },
                            React.createElement(Input, { id: inputId, name: `${fieldName}-filter`, ariaLabel: filterAriaLabel || `Filter ${label}`, placeholder: filterPlaceholder || `Filter ${label}`, "aria-controls": dropdownMenuId, iconRight: true, icon: "filter", value: filterValue, onClear: () => setFilterValue(''), onFocus: e => e.target.select(), onChange: e => setFilterValue(e.target.value), disabled: disabled, condensed: condensed }))) : null,
                        React.createElement("div", { className: "cb-multiselect-checkbox-list", id: dropdownMenuId, role: "region", "aria-labelledby": dropdownId },
                            selectAll && (React.createElement("div", { className: "cb-divider cb-multiselect-checkbox-all" },
                                React.createElement(Checkbox, { labelPosition: checkboxLabelPosition, label: React.createElement("span", null,
                                        "Select All ",
                                        filterValue && !filterRequired ? 'Filtered' : '',
                                        ' ',
                                        label), disabled: availableOptions.length <= 0, checked: allSelected, condensed: condensed, ariaDescribedby: filterRequired && typeof maxCheckboxText === 'string'
                                        ? `checkboxAllText${uid}`
                                        : undefined, onChange: (checked) => {
                                        onSelectAll && onSelectAll(checked);
                                        updateSelected(checked
                                            ? availableOptions
                                            : selected.filter((s) => !availableOptions.find((o) => o.value === s.value)));
                                    } }))),
                            filterRequired && typeof maxCheckboxText === 'string' ? (React.createElement("p", { className: "cb-multiselect-checkbox-all-text", id: `checkboxAllText${uid}` }, availableOptions &&
                                maxCheckboxText.replace('{availableOptions}', availableOptions.length.toString()))) : null,
                            !grouped &&
                                !filterRequired &&
                                availableOptions.map((o, index) => (React.createElement(Checkbox, { labelPosition: checkboxLabelPosition, key: `checkbox${selectId}-${index}`, label: checkboxLabelFunc ? checkboxLabelFunc(o.label, o.desc) : o.label, disabled: o.disabled, condensed: condensed, checked: (allSelected && !o.disabled) ||
                                        o.isChecked ||
                                        (Boolean(selected.find((s) => s.value === o.value)) &&
                                            !o.disabled), className: o.className, onChange: (checked) => {
                                        o.onChange
                                            ? o.onChange(checked)
                                            : updateSelected(checked
                                                ? [...selected, o]
                                                : selected.filter((s) => s.value !== o.value));
                                        // close when something is checked
                                        closeOnSelect && setExpanded(!expanded);
                                    } }))),
                            grouped &&
                                !filterRequired &&
                                Object.entries(groupBy(availableOptions, 'groupTitle')).map(([key, value], index) => {
                                    var _a, _b, _c, _d;
                                    return (React.createElement("fieldset", { key: `group${key}-${index}`, "aria-labelledby": `group${key}-${index}` },
                                        React.createElement("div", { className: cn('cb-divider', groupedCheckbox && 'cb-multiselect-grouped-checkbox') },
                                            groupedCheckbox ? (React.createElement(Checkbox, { labelPosition: checkboxLabelPosition, label: groupLabelFunc ? (groupLabelFunc(key, (_a = value[0]) === null || _a === void 0 ? void 0 : _a.groupDesc)) : (React.createElement("span", null, key)), disabled: value.length <= 0, checked: allSelected || groupIsSelected(key), condensed: condensed, labelId: `checkbox${key}-${index}`, className: cn('cb-checkbox-nested', groupIsMixed(key) && 'cb-checkbox-mixed'), "aria-checked": groupIsMixed(key) ? 'mixed' : undefined, onChange: (checked) => {
                                                    updateSelected(checked
                                                        ? [
                                                            ...new Map([
                                                                ...selected,
                                                                ...getGroup(key),
                                                            ].map(v => [v.value, v])).values(),
                                                        ]
                                                        : selected.filter((s) => s.groupTitle !== key));
                                                } })) : (React.createElement("p", { className: "cb-group-title", id: `group${key}-${index}` }, groupLabelFunc
                                                ? groupLabelFunc(key, (_b = value[0]) === null || _b === void 0 ? void 0 : _b.groupDesc)
                                                : key)),
                                            ((_c = value[0]) === null || _c === void 0 ? void 0 : _c.groupDesc) && groupedDescription && (React.createElement("p", { className: "cb-group-desc" }, (_d = value[0]) === null || _d === void 0 ? void 0 : _d.groupDesc)),
                                            React.createElement("div", { role: "group", "aria-labelledby": `checkbox${key}-${index}` }, value.map((o, index) => (React.createElement(Checkbox, { labelPosition: checkboxLabelPosition, key: `checkbox${selectId}-${index}`, label: checkboxLabelFunc
                                                    ? checkboxLabelFunc(o.label, o.desc)
                                                    : o.label, disabled: o.disabled, condensed: condensed, checked: (allSelected && !o.disabled) ||
                                                    o.isChecked ||
                                                    (Boolean(selected.find((s) => s.value === o.value)) &&
                                                        !o.disabled), className: o.className, onChange: (checked) => {
                                                    o.onChange
                                                        ? o.onChange(checked)
                                                        : updateSelected(checked
                                                            ? [...selected, o]
                                                            : selected.filter((s) => s.value !== o.value));
                                                    // close when something is checked
                                                    closeOnSelect && setExpanded(!expanded);
                                                } })))))));
                                }),
                            React.createElement("div", { "aria-live": "polite" }, availableOptions.length <= 0 && React.createElement("p", { className: "cb-no-results" }, noResultMsg))))) : null),
                validation && hasError ? (React.createElement(Icon, { name: "exclamation", className: "cb-validation-icon", decorative: true })) : (validation && React.createElement("i", { className: "cb-validation-icon", "aria-hidden": "true" }))),
            validation && inputMsg ? (React.createElement("p", { className: `cb-input-helper cb-validation-${valid}`, id: msgId || '', role: validationMsgRole }, inputMsg)) : null,
            React.createElement("span", { role: "status", className: "sr-only" }, expanded &&
                (availableOptions.length <= 0 ? (React.createElement(React.Fragment, null,
                    "Option list has been filtered, no results out of ",
                    optionList.length,
                    " options")) : (React.createElement(React.Fragment, null,
                    availableOptions.length,
                    " options are available"))))),
        tags && tagPosition === 'bottom' && selected.length > 0 && (React.createElement("div", { className: "cb-margin-top-24" },
            React.createElement(TagSet, { disabled: disabled, tagIcon: tagIcon, small: tagSmall, label: `Selected ${label}`, offScreen: "Remove", tags: selected.filter((s) => !s.disabled).map((s) => s.label), onClick: (tagName, e) => {
                    e.preventDefault();
                    if (!disabled) {
                        const remainingItems = selected.filter((s) => s.label !== tagName && !s.disabled);
                        updateSelected(remainingItems);
                        if (remainingItems.length <= 0) {
                            anchorRef.current && anchorRef.current.focus();
                        }
                    }
                } })))));
};
//# sourceMappingURL=MultiSelect.js.map